<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="1" class="form-group" style="min-width: 105px; max-width: 120px;">
        <label>Thao tác</label>
        <div class="dropdown btn-group" style="height: 36px;">
          <button class="btn">
            <div class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.selectedAll"
                  @change="changeSelectAll"
                  id="selectedAll"
                />
                <label class="custom-control-label" for="selectedAll"></label>
              </div>
            </div>
          </button>
          <button
            type="button"
            class="dropdown-toggle dropdown-toggle-split btn"
            data-toggle="dropdown"
            aria-expanded="false"
            aria-haspopup="true"
          ></button>
          <div class="dropdown-menu">
            <button
              :disabled="actionData.model.listUserSelectedId.length === 0"
              class="dropdown-item"
              @click="setupSelectOneAction('delete_list')"
              color="danger"
            >
              <CIcon name="cil-trash" style="danger" class="mr-2"/>
              Xóa tất cả
            </button>
          </div>
        </div>
      </CCol>
      <CCol sm="2" xs="12">
        <BaseInput
          :options="usernameInput.options"
          :data="usernameInput.data"
          :listener="usernameInput.listener"
        />
      </CCol>
            <CCol sm="2" xs="12">
              <BaseSelect :options="orgSelect.options" :data="orgSelect.data"
                          ref="orgSelect"></BaseSelect>
            </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;&nbsp; Tải lại
            </CButton>
            <CButton
              style="float: right;"
              color="primary"
              v-c-tooltip.hover="'Thêm mới'"
              class="btn-action-primary"
              @click="$router.push('/user-management/new.html')"
            >
              <i class="fa fa-plus"></i>&nbsp;&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable">
          <template #checkbox="{item}">
            <td class="group-checkbox">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  v-model="actionData.model.listUserSelectedId"
                  :value="item.id"
                  :id="item.id"
                  v-c-tooltip.hover="'Selected'"
                />
                <label class="custom-control-label" :for="item.id"></label>
              </div>
            </td>
          </template>

          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #userName="{item}">
            <td>
              <span style="font-weight: 550;" :key="item.userName" v-c-tooltip.hover="item.userName">{{ item.userName }}</span>
            </td>
          </template>
          <template #fullName="{item}">
            <td>
              <span style="font-weight: 550;">{{ item.fullName || 'N/A' }}</span>
            </td>
          </template>
          <template #enabled="{item}">
            <td>
                <span v-if="item.enabled == 1" class="dot-custom dot-success">
                Hoạt động
              <BaseSwitch class="mx-1" color="success" checked variant="3d" v-c-tooltip.hover="'Vô hiệu hóa'"
                          v-bind="labelIcon"
                          @update:checked="setupSelectOneAction('update_enabled', item.id, item.username, item.enabled)"
              />
              </span>
              <span v-else class="dot-custom dot-danger">
                Vô hiệu hóa
                <BaseSwitch class="mx-1" color="danger" variant="3d" v-c-tooltip.hover="'Hoạt động'"
                            v-bind="labelIcon"
                            @update:checked="setupSelectOneAction('update_enabled', item.id, item.username, item.enabled)"/>
              </span>
            </td>
          </template>
          <template #role="{item}">
            <td class="td-roles">
              <CBadge
                  v-for="role in item.role.split(',')"
                  :key="role"
                  color="infor"
                  class="mr-1">{{ role }}</CBadge>
            </td>
          </template>
          <template #orgName="{item}">
            <td class="td-roles">
              <CBadge color="light" class="mr-1">{{ item.orgName }}</CBadge>
            </td>
          </template>

          <template #action="{item}">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton
                  color="info"
                  variant="outline"
                  v-c-tooltip.hover="'Cập nhật'"
                  square
                  size="sm"
                  @click="$router.push(`/user-management/${item.id}/managed-user.html`)"
                >
                  <CIcon name="cil-pencil"/>
                </CButton>
                <CButton color="info" variant="outline" class="ml-1"
                         v-c-tooltip.hover="'Đặt lại mật khẩu'" square size="sm"
                         @click=" setupSelectOneAction('reset_password', item.id, item.username)">
                  <CIcon name="cil-loop-circular"/>
                </CButton>
                <CButton
                  color="danger"
                  variant="outline"
                  class="ml-1"
                  square
                  size="sm"
                  v-c-tooltip.hover="'Xóa'"
                  @click="
                    setupSelectOneAction('delete_one', item.id, item.username)
                  "
                >
                  <CIcon name="cil-trash"/>
                </CButton>
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSwitch from "@/views/base/BaseSwitch";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: "UsersList",
  components: {
    BaseSwitch,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    let actionTypeMapping = new Map();

    actionTypeMapping.set("reset_password", {
      url: "/users/resetPassword",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "đặt lại mật khẩu",
          "tài khoản",
          that.actionData.model.userSelectedName
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {id: that.actionData.model.userSelectedId};
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Reset mật khẩu tài khoản " + that.actionData.model.userSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_one", {
      url: "/users/deleteUsers",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "xóa",
          "tài khoản",
          that.actionData.model.userSelectedName
        );
      },
      isJsonContentType: false,
      // type: 'PUT',
      dataSubmit: function () {
        return {id: that.actionData.model.userSelectedId};
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa tài khoản " + that.actionData.model.userSelectedName + " thành công"});
        that.loadDataMainTable();
      }
    });

    actionTypeMapping.set("delete_list", {
      url: "/users/deleteLsUsers",
      titlePopup: function () {
        return that.$helper.setupTitleAction("xóa", "các tài khoản", "đã chọn");
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          lsId: that.actionData.model.listUserSelectedId
        };
      },
      successCallback: function () {
        that.actionData.model.listUserSelectedId = [];
        that.showSuccessMsg({message: "Xóa danh sách tài khoản thành công"});
        that.loadDataMainTable();
      },
    });

    actionTypeMapping.set("update_enabled", {
      url: "/users/updateEnableUser",
      titlePopup: function () {
        return that.$helper.setupTitleAction(that.actionData.model.userIsEnable == true ? "vô hiệu hóa" : "hoạt động", "tài khoản", that.actionData.model.userSelectedName);
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.userSelectedId
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: that.actionData.model.userIsEnable == true ? "Vô hiệu hóa tài khoản thành công" : "Hoạt động tài khoản thành công"});
        that.loadDataMainTable();
      },
    });

    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          userSelectedId: null,
          userSelectedName: null,
          userIsEnable: null,
          listUserSelectedId: []
        }
      },
      usernameInput: {
        options: {
          placeholder: "Tên đăng nhập",
          label: 'Tên đăng nhập'
        },
        data: {
          name: "username",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      orgSelect: {
        options: {
          label: "Tổ chức",
          selectAllText: "Tất cả tổ chức",
          filter: false,
          'keyField': 'value',
          'valueField': 'text',
        },
        data: {
          model: "",
          name: 'orgId',
          source: {
            url: "/organization/list-org-active",
            response: function (dataResponse) {
              return dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            {key: "checkbox", label: "#"},
            // {key: "createDate", label: "Ngày tạo"},
            {key: "userName", label: "Tên đăng nhập"},
            {key: "fullName", label: "Họ tên"},
            {key: "phone", label: "SĐT"},
            {key: "email", label: "Email"},
            {key: "enabled", label: "Trạng thái"},
            {key: "role", label: "Quyền"},
            {key: "orgName", label: "Tổ chức"},
            {key: "action", label: "Thao tác"}
          ],
          slots: ["checkbox", "userName", "fullName", "enabled", "role", "createDate", "orgName", "action"],
        },
        dataSource: {
          url: "/users/listUsers",
          dataSubmit: function () {
            return that.$helper.setupDataSubmit(that.$data);
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    changeSelectAll: function (event) {
      let listUserSelectedId = this.actionData.model.listUserSelectedId;
      if (this.actionData.model.selectedAll) {
        this.actionData.model.listUserSelectedId = [];

        this.$refs.mainTable.items.forEach(each => {
          this.actionData.model.listUserSelectedId.push(each.id);
        });
      } else {
        this.actionData.model.listUserSelectedId = [];
      }
    },
    setupSelectOneAction: function (actionTypeKey, userSelectedId, userSelectedName, userIsEnable) {
      let actionData = this.actionData.model;
      actionData.userSelectedId = userSelectedId || null;
      actionData.userSelectedName = userSelectedName || null;
      actionData.userIsEnable = userIsEnable || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
    // setupSelectMoreAction: function (actionTypeKey) {
    //   this.$refs.actionModal.setCurrAction(actionTypeKey);
    // }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    "actionData.model.listUserSelectedId": function (newValue) {
      let that = this;
      if (newValue.length === that.$refs.mainTable.items.length) {
        that.actionData.model.selectedAll = true;
      } else {
        that.actionData.model.selectedAll = false;
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
